import { useState, useCallback } from 'react'
import { Provider } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Cabecera from './components/cabecera/Cabecera'
import { CarritoProvider } from './components/context/carritoContext'
import { LoginProvider } from './components/context/loginContext'
import { MenuProvider } from './components/context/menuContext'
import { UsuarioProvider } from './components/context/usuarioContext'
import Cuerpo from './components/Cuerpo'
import { store } from './store'

import 'react-toastify/dist/ReactToastify.css'
import './resources/css/main.css'
import './resources/css/styling.css'
import './resources/css/bootstrap-grid.css'
import './resources/css/font-awesome.css'

const App = () => {
  const [verFotoPerfil, setVerFotoPerfil] = useState(false)
  const [showAyuda, setShowAyuda] = useState()
  const [script, setScript] = useState()
  const navigate = useNavigate()

  const cambiarImagenPerfil = useCallback(() => {
    setVerFotoPerfil(true)
  }, [])

  const mostrarAyuda = useCallback(() => {
    setShowAyuda((prev) => !prev)
    setScript(false)
  }, [])

  window.addEventListener('storage', (e) => checkStorage(e))

  const checkStorage = (e) => {
    if (
      (e.key === 'idUsuario' && e.oldValue !== e.newValue) ||
      (e.key === 'empid' && e.oldValue !== e.newValue) ||
      (e.key === 'usuario' && e.oldValue !== e.newValue)
    ) {
      localStorage.clear()
      navigate('/')
    }
  }

  return (
    <Provider store={store}>
      <UsuarioProvider>
        <CarritoProvider>
          <LoginProvider>
            <MenuProvider>
              <div
                style={{
                  height: '100vh',
                  width: '100vw',
                  display: 'flex',
                  flexDirection: 'column',
                  overflowX: 'hidden' // Prevent horizontal scrolling
                }}
              >
                <ToastContainer position="bottom-right" draggable closeOnClick />
                <header
                  style={{
                    width: '100%',
                    flexShrink: 0,
                    position: 'relative',
                    top: 'auto',
                    left: 'auto',
                    backgroundColor: '#082567',
                    zIndex: 1200,
                    height: 'auto',
                    minHeight: '120px'
                  }}
                >
                  {localStorage.getItem('empid') && (
                    <Cabecera verFotoPerfil={verFotoPerfil} showAyuda={showAyuda} script={script} />
                  )}
                </header>
                <main
                  style={{
                    maxWidth: '100%', // Ensure it never exceeds viewport width
                    width: '100vw',
                    flex: 1,
                    overflow: 'auto'
                  }}
                >
                  <div
                    className="container-fluid"
                    style={{
                      padding: 0,
                      margin: 0,
                      maxWidth: '100%', // Ensure it never exceeds viewport width
                      width: '100vw',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div
                      className="row"
                      style={{
                        maxWidth: '100%', // Ensure it never exceeds viewport width
                        width: '100vw'
                      }}
                    >
                      <Cuerpo
                        cambiarImagenPerfil={cambiarImagenPerfil}
                        mostrarAyuda={mostrarAyuda}
                      />
                    </div>
                  </div>
                </main>
              </div>
            </MenuProvider>
          </LoginProvider>
        </CarritoProvider>
      </UsuarioProvider>
    </Provider>
  )
}

export default App
